import { useReceiptBatchStore } from './ReceiptBatchContext';
import { useShallow } from 'zustand/react/shallow';
import { useMemo } from 'react';
import type { TaxItem } from './form/ServiceProviderReceiptBatchForm';

export const useTaxItemsAndDefault = (): {
  taxItems: Array<TaxItem & { id: string }>;
  defaultTaxCode: (TaxItem & { id: string }) | undefined;
} => {
  const [defaultTaxCodeId, taxConfigurations] = useReceiptBatchStore(
    useShallow((state) => [
      state.serviceProvider?.defaultTaxCodeId,
      state.taxConfigurations,
    ])
  );

  const taxItems = useMemo<Array<TaxItem & { id: string }>>(
    () =>
      taxConfigurations?.map((taxConfiguration) => ({
        id: taxConfiguration.id,
        taxName: taxConfiguration.name,
        countryId: taxConfiguration.countryId,
        displayExplanation: taxConfiguration.displayTaxRatioExplanation,
        taxAmount: taxConfiguration.taxRatio / 100,
        taxAmountInPercentage: taxConfiguration.taxRatio,
        explanationLong: taxConfiguration.taxRatioExplanation,
        // Todo: Currently there is no short explanation in the tax configuration
        explanationShort: undefined,
        paragraph: taxConfiguration.paragraph,
      })) ?? [],
    [taxConfigurations]
  );

  const defaultTaxCode = useMemo(() => {
    return taxItems.find((tax) => tax.id === defaultTaxCodeId);
  }, [taxItems, defaultTaxCodeId]);

  return {
    taxItems: taxItems,
    defaultTaxCode,
  };
};
